import { render, staticRenderFns } from "./BindEip.vue?vue&type=template&id=645e0fcc&"
import script from "./BindEip.vue?vue&type=script&lang=js&"
export * from "./BindEip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports